import { store } from 'quasar/wrappers'
import { createStore } from 'vuex'

import app from './app'
import auth from './auth'
import brands from './brands'
import colors from './colors'
import mechanismCovers from './mechanism-covers'
import modules from './modules'
import groups from './groups'
import products from './products'
import productPresets from './product-presets'
import productModules from './product-modules'
import quote from './quote'
import shoppingCart from './shopping-cart'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(function (/* { ssrContext } */) {
  const Store = createStore({
    modules: {
      app,
      auth,
      brands,
      colors,
      'mechanism-covers': mechanismCovers,
      modules,
      groups,
      products,
      quote,
      'product-presets': productPresets,
      'product-modules': productModules,
      'shopping-cart': shoppingCart
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: process.env.DEBUGGING
  })

  return Store
})
